<template>
	 <v-container>
		 <v-dialog title="修改教师提成计算价格" v-model="hideShow" width="500" persistent>
			<v-card>
				<v-card-title>
					<span>修改教师分成计算价格</span>
					<v-spacer></v-spacer>
					<v-icon @click="cancel">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-4">
					<v-row dense>
						<v-col cols="12">
							<span style="color: red;">注:只有教师绩效提成方式是“按比例分成”,且配置"按指定提成价格计算"提成时需要配置</span>
						</v-col>
					</v-row>
					<v-row dense class="mt-2">
						<v-col cols="12">
							<v-text-field label="原教师提成计算价格" v-model="add.originPrice" disabled dense outlined></v-text-field>
						</v-col>
						<v-col cols="12">
							<v-text-field label="新教师提成计算价格" v-model="add.teacherBonusPrice" type="number" dense outlined></v-text-field>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="cancel">取消</v-btn>
					<v-btn @click="submitUpdate" :loading="add.submitting" color="success">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	 </v-container>
</template>

<script>
	export default {
		name:"update-teacher-bonus-price",
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			classStudent:{
				type:Object,
				default:null
			}
		},
		watch:{
			show(newVal,oldVal){
				console.log("newVal",newVal);
				this.hideShow = newVal;
				if(this.hideShow){
					this.add.teacherBonusPrice = "";
					this.add.originPrice = this.classStudent.teacherBonusPrice;
				}
			}
		},
		data(){
			return {
				add: {
					submitting:false,
					originPrice:"",
					teacherBonusPrice:""
				},
				hideShow:this.show
			}
		},
		mounted() {
			console.log("update teacher bonus price mounted");
		},
		methods:{
			submitUpdate(){
				console.log("提交修改");
				
				// 提交修改价格
				if (!this.add.teacherBonusPrice) {
					that.$noty.error("请输入新的教师提成计算价格");
					return
				}
				this.add.submitting = true;
							
				// api
				const that = this;
		
				let url = `/edu/class/student/teacher/bonus/price/update`;
				let postData = {
					classStudentId:this.classStudent.id,
					newPrice:this.add.teacherBonusPrice
				};
							
				this.axios.post(url, postData).catch(() => {
					that.add.submitting = false;
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");
							that.add.submitting = false;
							
							// 触发调用者success事件
							that.$emit("success",that.add.teacherBonusPrice);
							
							return;
						} else {
							that.add.submitting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.add.submitting = false;
						that.$noty.error('网络请求失败');
					}
							
				});
				
				
			},
			cancel(){
				this.$emit("cancel","");
			}
		}
	}
	
</script>

